var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.95833 0.708252H12.0417V2.12492H14.875V8.49992H13.4583V3.54159H12.0417V4.95825H4.95833V3.54159H3.54167V14.8749H8.5V16.2916H2.125V2.12492H4.95833V0.708252ZM6.375 3.54159H10.625V2.12492H6.375V3.54159ZM14.1667 9.91658V12.7499H17V14.1666H14.1667V16.9999H12.75V14.1666H9.91667V12.7499H12.75V9.91658H14.1667Z",
    fill: "#A025FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/taskIcon.97008a12f60de6fc0d66c1451ff6c61d.svg";
export { ForwardRef as ReactComponent };